var ReplaceDashAndCapitalizeValueConverter = /** @class */ (function () {
    function ReplaceDashAndCapitalizeValueConverter() {
    }
    ReplaceDashAndCapitalizeValueConverter.prototype.toView = function (value) {
        if (!value)
            return "";
        var replaced = value.replace(/-/g, " ");
        return "".concat(replaced[0].toUpperCase()).concat(replaced.substring(1, replaced.length));
    };
    return ReplaceDashAndCapitalizeValueConverter;
}());
export { ReplaceDashAndCapitalizeValueConverter };
